/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { apiClient, handleTokenAuth } from './api'
import { handleError } from './error';

export function loadUserActions() {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.LOADING_USER_TRACKER_ACTIONS });

    const options = handleTokenAuth(getState);
    apiClient.get('users/current/actions', options)
      .then(response => {
        dispatch({
          type: actionTypes.LOADED_USER_TRACKER_ACTIONS,
          data: response.data.data,
        });
      })
      .catch(handleError(dispatch, actionTypes.ERROR_USER_TRACKER_ACTIONS));
  }
}

export function loadUserActionsSummary() {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.LOADING_USER_TRACKER_ACTIONS_SUMMARY });

    const options = handleTokenAuth(getState);
    apiClient.get('users/current/actions/summary', options)
      .then(response => {
        dispatch({
          type: actionTypes.LOADED_USER_TRACKER_ACTIONS_SUMMARY,
          data: response.data.data,
        });
      })
      .catch(handleError(dispatch, actionTypes.ERROR_USER_TRACKER_ACTIONS_SUMMARY));
  }
}

